package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.sales_group.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsEvent
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsState
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.LineStyle

@Composable
fun OptionSaleGroupTabContent(
    windowSizeMode: WindowSizeModeEnum,
    state: OptionsState,
    event: (OptionsEvent) -> Unit,
    onSwipeLeft:()->Unit={},
)
{

    Column(
        modifier = Modifier
            .fillMaxSize()
            .margin(leftRight = Dimen.mediumPadding,)
            .padding(Dimen.extraLargePadding)
            .borderRadius(Dimen.semiLargeRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
    )
    {
        if (windowSizeMode== WindowSizeModeEnum.Desktop){
            Row()
            {
                generalContent(
                    state=state,
                    event=event
                )
            }
        }else{
            Column()
            {
                generalContent(
                    state=state,
                    event=event
                )
            }
        }


        MediumContentTitle(
            title = Strings.current().accountingPercent,
            marginBottom = Dimen.normalPadding,

        )

        if (windowSizeMode== WindowSizeModeEnum.Desktop){
            Row() {
                accountingContent(
                    state=state,
                    event=event
                )
            }
        }else{
            Column()
            {
                accountingContent(
                    state=state,
                    event=event
                )
            }
        }




    }

}

@Composable
private fun accountingContent(
    state: OptionsState,
    event: (OptionsEvent) -> Unit
) {
    CustomEditText(
        modifier = Modifier,
        width = Dimen.normalEditTextWidth,
        label = Strings.current().financialReduced,
        marginRight = Dimen.largePadding,
        isRequired = false,
        value = state.selectedSaleGroup?.accountingReduced ?: "",
        hint = "",
        isOutlinedEditText = true,
        onFocusIn = {},
        onFocusOut = {
            event(
                OptionsEvent.UpdateSaleGroup(
                    dataTitle = ApiUtils.Field.accountingReduced,
                    dataValue = it
                )
            )
        },
        onInputChange = {it, validation ->

        },
    )

    CustomEditText(
        modifier = Modifier,
        width = Dimen.normalEditTextWidth,
        isRequired = false,
        label = Strings.current().fibuNormal,
        marginRight = Dimen.largePadding,
        value = state.selectedSaleGroup?.accountingNormal ?: "",
        hint = "",
        isOutlinedEditText = true,
        onFocusIn = {},
        onFocusOut = {
            event(
                OptionsEvent.UpdateSaleGroup(
                    dataTitle = ApiUtils.Field.accountingNormal,
                    dataValue = it
                )
            )
        },
        onInputChange = {it, validation ->

        },
    )

    CustomEditText(
        modifier = Modifier,
        inputType = InputType.Number,
        isRequired = false,
        width = Dimen.normalEditTextWidth,
        label = Strings.current().accounting,
        value = state.selectedSaleGroup?.accountingZeroPercent ?: "",
        hint = "",
        isOutlinedEditText = true,
        onFocusIn = {},
        onFocusOut = {
            event(
                OptionsEvent.UpdateSaleGroup(
                    dataTitle = ApiUtils.Field.accountingZeroPercent,
                    dataValue = it
                )
            )
        },
        onInputChange = {it, validation ->

        },
    )
}

@Composable
private fun generalContent(
    state: OptionsState,
    event: (OptionsEvent) -> Unit
) {
    CustomEditText(
        modifier = Modifier,
        label = Strings.current().number,
        value = state.selectedSaleGroup?.acountNum ?: "",
        marginRight = Dimen.largePadding,
        isRequired = false,
        hint = "",
        isOutlinedEditText = true,
        onFocusIn = {},
        onFocusOut = {
            event(
                OptionsEvent.UpdateSaleGroup(
                    dataTitle = ApiUtils.Field.acountNum,
                    dataValue = it
                )
            )
        },
        onInputChange = {it, validation ->

        },
    )

    CustomEditText(
        modifier = Modifier,
        label = Strings.current().receiptName,
        value =state.selectedSaleGroup?.name ?: "",
        isRequired = false,
        hint = "",
        marginBottom = Dimen.extraLargePadding,
        isOutlinedEditText = true,
        onFocusIn = {},
        onFocusOut = {
            event(
                OptionsEvent.UpdateSaleGroup(
                    dataTitle = ApiUtils.Field.name,
                    dataValue = it
                )
            )
        },
        onInputChange = {it, validation ->

        },
    )
}